import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NotificationTypes } from '@app/core/notifications/notification-types';
import { Image } from '@app/entities/images/interfaces/image';

@Component({
  selector: 'app-message-notification',
  templateUrl: './message-notification.component.html',
  styleUrls: ['./message-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageNotificationComponent {
  @Input({ required: true })
  type!: NotificationTypes;

  @Input({ required: true })
  title!: string;

  @Input({ required: true })
  message!: string;

  @Input()
  image?: Image;

  protected NotificationTypes = NotificationTypes;
}
